import { createAction, props } from "@ngrx/store";

export const basicSearch = createAction('[Search] Add Basic Search', props<{ basicCriteria: string }>());
export const branches = createAction('[Search] Add Branches', props<{ branches: any[] }>());
export const locationsFrom = createAction('[Search] Add Locations From', props<{ locationsFrom: any[] }>());
export const locationsTo = createAction('[Search] Add Locations To', props<{ locationsTo: any[] }>());
export const customers = createAction('[Search] Add Customers', props<{ customers: any[] }>());
export const suppliers = createAction('[Search] Add Suppliers', props<{ suppliers: any[] }>());
export const resetState = createAction('[Search] Reset State');

